import { useStore } from 'vuex'
import { useBraintreeApi } from '@frontend/simple-billing'
import { computed } from 'vue'

export function useBraintree() {
	const store = useStore()
	const billingApiHost = store.getters['env/getProperty']('billingApiHost')

	const api = useBraintreeApi({
		baseURL: billingApiHost + 'v2/api/braintree/'
	})

	const userData = computed(() => ({
		user_id: store.state.user.user_id,
		email: store.state.user.email
	}))

	const createSubscription = async (product) => {
		return await api
			.createSubscription({
				..._castProductToApiParams(product),
				intro_period_interval: 'month',
				intro_interval_month_count: 0,
				intro_price: 0,
				...userData.value
			})
			.then(async (response) => {
				return response.data.subscription
			})
			.catch((error) => Promise.reject(error?.response?.data))
	}

	return {
		createSubscription
	}
}

function _castProductToApiParams(product) {
	return {
		trial_days: product.trial_days,
		trial_price: 0,
		regular_interval_month_count: product.duration_months,
		regular_price: product.product_price,
		currency: product.currency,
		payment_method_nonce: product.payment_method_nonce
	}
}
